/* "Who else is editing this post" avatars (OnlineUsers / useOnlineUsers).
 *
 * Presence lives in the `adminonlineusers` Realtime Database instance, at
 * /$slugName/$firebaseUid. Two constraints shape these helpers:
 *
 * - The database rules validate every entry (email and name must be present
 *   strings), and Firebase rejects `undefined` outright, so the entry is
 *   normalized here instead of trusting the decoded admin JWT.
 * - Writing requires a Firebase session, and the CMS has exactly one: the
 *   custom token minted by the `chatToken` mutation. Its claims are minted for
 *   a specific post, so the session is reused per post rather than per caller
 *   (see firebase/ensureFirebaseAuth.js). */

const presenceEntry = ({ email, name, imageUrl } = {}) => ({
  email: typeof email === 'string' ? email : '',
  name: typeof name === 'string' ? name : '',
  imageUrl: typeof imageUrl === 'string' && imageUrl !== '' ? imageUrl : null,
});

const needsFirebaseSignIn = ({ currentUid, signedInSlugName, slugName }) => {
  if (!currentUid) return true;
  return signedInSlugName !== slugName;
};

/* The node also holds entries written before presence was keyed by Firebase
 * uid, and the rules only validate what is written from now on, so anything
 * that is not a well formed entry is dropped instead of reaching the avatars
 * (`users[key].email` on a stale string entry used to throw). */
const presenceList = (users) => {
  if (!users || typeof users !== 'object') return [];
  return Object.keys(users)
    .filter((uid) => {
      const entry = users[uid];
      return Boolean(entry) && typeof entry === 'object' && typeof entry.email === 'string' && entry.email !== '';
    })
    .map(uid => ({ uid, ...presenceEntry(users[uid]) }));
};

module.exports = { presenceEntry, needsFirebaseSignIn, presenceList };
